import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
} from '@material-ui/core';
import {
  Help,
  ExitToApp,
  CompareArrows,
} from '@material-ui/icons';
import { openSupportRequestModal } from '@pingum/app-state-management/supportRequest/actions';
import * as profileKeys from '@pingum/api-services/UserService/profileKeys';

const getSrc = (profile) => {
  const link = profile[profileKeys.avatar] === undefined

    ? profile.picture
    : profile[profileKeys.avatar];
    // to avoid browser cache append random param when updated
  const key = profile.updated_at
    ? profile.updated_at
    : profile.created_at;
  if (link && link.indexOf('http') >= 0) {
    return `${link}?date=${key}`;
  }
  return link;
};

export class UserMenuComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      element: null,
    };
  }

  handleOpen = (e) => {
    this.setState({
      open: true,
      element: e.currentTarget,
    });
  }

  handleClose = () => {
    this.setState({
      open: false,
      element: null,
    });
  }

  render() {
    return (
      <div>
        <IconButton
          onClick={this.handleOpen}
          id="menu-btn"
          aria-owns={this.state.open
            ? 'menu-appbar'
            : null}
          aria-haspopup="true"
        >
          <Avatar src={getSrc(this.props.profile)} />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={this.state.element}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          anchorPosition={{
            top: -10,
            left: 0,
          }}
          open={this.state.open}
          onClose={this.handleClose}
        >
          {
            !!this.props.tenant
              && (
                <a
                  href={`${window.location.protocol}//${env.REACT_APP_DOMAIN}/organizations`}
                  tabIndex={-1}
                  style={{ color: 'black' }}
                >
                  <MenuItem>
                    <ListItemIcon>
                      <CompareArrows />
                    </ListItemIcon>
                    Switch organizations
                  </MenuItem>
                </a>
              )
          }
          <MenuItem onClick={this.props.openSupportRequestModal}>
            <ListItemIcon>
              <Help />
            </ListItemIcon>
            Support
          </MenuItem>
          <Link
            to="/logout"
            href="/logout"
            tabIndex={-1}
            style={{ color: 'black' }}
          >
            <MenuItem>
              <ListItemIcon>
                <ExitToApp />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Link>
        </Menu>
      </div>
    );
  }
}

UserMenuComponent.propTypes = {
  openSupportRequestModal: PropTypes.func,
  profile: PropTypes.object,
  tenant: PropTypes.object,
};

UserMenuComponent.defaultProps = {
  openSupportRequestModal: () => {},
  profile: {},
  tenant: null,
};

export const mapStateToProps = (state) => ({
  auth: state.auth,
  profile: state.user.user,
  tenant: state.tenant.tenant,
});

export const mapDispatchToProps
  = (dispatch) => ({ openSupportRequestModal: () => dispatch(openSupportRequestModal()) });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserMenuComponent);
